import { Referral } from "#/services/firebase/firebase.types";

import { ReferralListItem } from "./ReferralLinks.types";

export const FIRST_REFERRAL_VOLUME = 75_000;
export const NEXT_REFERRAL_VOLUME = 200_000;

export const isEligibleForNewReferral = (
  volume: number,
  referralCount: number,
): boolean => {
  if (referralCount === 0) return volume >= FIRST_REFERRAL_VOLUME;

  return volume >= NEXT_REFERRAL_VOLUME * referralCount;
};

export const getTotalReferralsUnlocked = (volume: number): number => {
  if (volume < FIRST_REFERRAL_VOLUME) return 0;

  return 1 + Math.floor(volume / NEXT_REFERRAL_VOLUME);
};

export const getReferralsAvailable = (
  volume: number,
  referralCount: number,
): number => {
  return getTotalReferralsUnlocked(volume) - referralCount;
};

export const getNextReferralProgress = (
  volume: number,
): { value: number; maxValue: number } => {
  if (volume < FIRST_REFERRAL_VOLUME) {
    return { value: volume, maxValue: FIRST_REFERRAL_VOLUME };
  }

  const previousThreshold =
    FIRST_REFERRAL_VOLUME +
    Math.floor((volume - FIRST_REFERRAL_VOLUME) / NEXT_REFERRAL_VOLUME) *
      NEXT_REFERRAL_VOLUME;

  return {
    value: volume - previousThreshold,
    maxValue: NEXT_REFERRAL_VOLUME,
  };
};

export const createReferralLinkItems = (
  referrals: Referral[],
): ReferralListItem[] => {
  return referrals.map(
    (referral): ReferralListItem => ({
      code: referral.code,
      link: `${window.location.origin}/?referral=${referral.code}`,
      disabled: referral.usedCount >= referral.maxUses,
    }),
  );
};
